"use client";

import React from "react";
import type { AgentChartDialogPayload } from "@/lib/agent/agent-chart-payload";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/shadcn-components/ui/dialog";
import { AgentChartCanvas } from "./AgentChartCanvas";
import { useAgentChartModel } from "./useAgentChartModel";

interface AgentChartDialogProps {
  open: boolean;
  payload: AgentChartDialogPayload | null;
  onOpenChange: (open: boolean) => void;
}

export function AgentChartDialog({
  open,
  payload,
  onOpenChange,
}: AgentChartDialogProps) {
  const model = useAgentChartModel(payload?.spec ?? null);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex h-[96vh] max-h-[96vh] w-[96vw] max-w-[96vw] flex-col gap-2 p-4 sm:max-w-[96vw]">
        <DialogHeader className="shrink-0 space-y-1 pr-8">
          <DialogTitle className="text-sm font-medium truncate">
            {payload?.title ?? "Chart"}
          </DialogTitle>
        </DialogHeader>
        <AgentChartCanvas
          model={model}
          heightClass="h-[calc(96vh-4.5rem)]"
          className="px-0"
        />
      </DialogContent>
    </Dialog>
  );
}
